import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import { useQuery } from 'libs/query'
import { useParams } from 'libs/router'
import { useContext } from 'react'
import { useAxiosPrivate } from 'shared/hooks'
import { HistoryRes } from 'shared/types/general.types'
import { AuthContext } from 'store'

export const useFetchSaleHistory = () => {
	const params = useParams()
	const axiosPrivate = useAxiosPrivate()
	const { auth } = useContext(AuthContext)

	const { data: saleHistory, isPending: isSaleHistoryLoading } = useQuery<HistoryRes>({
		queryKey: queryKeys.sales.history(params.id as string),
		queryFn: () => axiosPrivate.get(apiRoutes.saleHistory(params.id as string)),
		enabled: !!auth.accessToken
	})

	return {
		saleHistory,
		isSaleHistoryLoading
	}
}
